import _stripTags from "../quill/stripTags.js";
import _orderByTime from "../eventGroups/orderByTime.js";
import _incodeTime from "../../lib/incodeTime.js";
import _tcLib from "../../lib/timecode.js";
const tcLib = _tcLib;
const incodeTime = _incodeTime;
const orderByTime = _orderByTime;
const stripTags = _stripTags;
export default (function subtractIncode(eventGroup, options) {
  // console.log(JSON.stringify(eventGroup, null, 4));
  if (options.incode === "00:00:00:00") {
    return eventGroup;
  }
  if (!eventGroup.events || eventGroup.events.length === 0) {
    return eventGroup;
  }
  if (!options.incode || options.incode === "auto") {
    eventGroup = orderByTime(eventGroup);
    if (!eventGroup.events.length) {
      return eventGroup;
    }
    if (stripTags(eventGroup.events[0].text).trim() == "") {
      eventGroup.events.shift();
      if (eventGroup.events.length === 0) {
        return eventGroup;
      }
    }
    let tcStart = tcLib.secToTc(eventGroup.events[0].start, options.frameRate, options.dropFrame);
    // console.log(tcStart);
    options.incode = tcStart.split(":")[0] + ":00:00:00";
  }
  let incodeSec = incodeTime.incodeLabelToMediaSeconds(options.incode, options.frameRate, options.dropFrame);

  // console.log(options.incode, incodeSec, options.frameRate, options.dropFrame);

  const firstTimed = eventGroup.events.find(event => {
    return event.start !== false && event.end !== false && event.start !== undefined && event.end !== undefined;
  });
  /* Allow half a frame: drop-frame incodes are wall-clock (01:00:00;00 = 3600s) but media time for that same frame is 3599.9964s */
  const halfFrameSec = tcLib.framesToSec(1, options.frameRate) / 2;
  if (firstTimed && firstTimed.start < incodeSec - halfFrameSec) {
    return eventGroup;
  }
  eventGroup.events.forEach((event, index, events) => {
    if (event.start === false || event.end === false || event.start === undefined || event.end === undefined) {
      return;
    }
    events[index].start = Math.max(0, events[index].start - incodeSec);
    events[index].end -= incodeSec;
  });
  return eventGroup;
});